
import React from 'react';
import { SimulationConfig } from './types';
import { SectionLabel } from './SectionLabel';
import { SmartInput } from './SmartInput';
import { Toggle } from './Toggle';

interface CameraSettingsSectionProps {
  config: SimulationConfig;
  setConfig: React.Dispatch<React.SetStateAction<SimulationConfig>>;
}

export const CameraSettingsSection: React.FC<CameraSettingsSectionProps> = ({ config, setConfig }) => {
  return (
    <div className="w-full flex flex-col gap-3 p-4 rounded-3xl border bg-teal-500/5 border-teal-500/20 mb-4">
      <SectionLabel icon="fa-video" darkMode={config.darkMode}>Cinematography</SectionLabel>
      
      <div className="flex items-center justify-between border border-teal-500/10 p-2 rounded-xl bg-teal-500/5">
          <div className="flex flex-col">
            <span className="text-[10px] font-black uppercase text-teal-500">Active Camera</span>
            <span className="text-[8px] opacity-60">Follows first ball</span>
          </div>
          <Toggle active={config.cameraFollow} onClick={() => setConfig(p => ({...p, cameraFollow: !p.cameraFollow}))} color="bg-teal-600" />
      </div>

      <div className={`flex flex-col gap-3 transition-all duration-300 ${config.cameraFollow ? 'opacity-100' : 'opacity-40 pointer-events-none'}`}>
          <SmartInput 
            label="Follow Speed (Smoothness)" 
            min={0.01} max={1.0} step={0.01} 
            value={config.cameraSmoothness} 
            onChange={v => setConfig(p => ({...p, cameraSmoothness: v}))} 
            darkMode={config.darkMode} 
          />
          <SmartInput 
            label="Velocity Lookahead" 
            min={0} max={20} step={0.1} 
            value={config.cameraLookahead} 
            onChange={v => setConfig(p => ({...p, cameraLookahead: v}))} 
            darkMode={config.darkMode} 
          />
          <SmartInput 
            label="Deadzone Radius" 
            min={0} max={300} 
            value={config.cameraDeadzone} 
            onChange={v => setConfig(p => ({...p, cameraDeadzone: v}))} 
            darkMode={config.darkMode} 
          />
          <SmartInput 
            label="Zoom Level" 
            min={0.2} max={5.0} step={0.1}
            value={config.cameraZoom} 
            onChange={v => setConfig(p => ({...p, cameraZoom: v}))} 
            darkMode={config.darkMode} 
          />
      </div>
    </div>
  );
};
